import React from 'react';
import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';
import { toast } from 'react-toastify';
import { EMPLOYEE_SHORTCUTS, USER_ROLES, ROUTES } from 'shared/consts';
import { NewUser } from 'shared/components';
import { history } from 'store/store';
import getArchivedEmployees from './getArchivedEmployees';
import { showPreloader, hidePreloader } from '../viewManagement';

const init = () => ({
  type: USER.RESTORE_EMPLOYEE_INIT,
});

export const success = () => ({
  type: USER.RESTORE_EMPLOYEE_SUCCESS,
});

const failure = () => ({
  type: USER.RESTORE_EMPLOYEE_FAILURE,
});

const restoreEmployee = userData => async dispatch => {
  dispatch(init());
  try {
    dispatch(showPreloader());
    const { data } = await Connector.restoreEmployee(userData.uuid);
    await dispatch(getArchivedEmployees());
    history.push(ROUTES.ARCHIVED_EMPLOYEES);
    await toast(
      <NewUser
        badgeType={EMPLOYEE_SHORTCUTS[Object.keys(USER_ROLES).find(role => USER_ROLES[role] === userData.role)]}
        first_name={userData.first_name}
        label="Przywrócono użytkownika"
        last_name={userData.last_name}
        phone={userData.phone}
      />,
    );
    dispatch(success(data));
    dispatch(hidePreloader());
    return null;
  } catch (err) {
    console.log(err);
    dispatch(failure());
    dispatch(hidePreloader());
    return err.response.data;
  }
};

export default restoreEmployee;
